"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorConfigToCSSVariables = void 0;
function ColorConfigToCSSVariables(colorConfig) {
    const styles = {};
    if (!colorConfig)
        return styles;
    const keys = Object.keys(colorConfig);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        styles[`--color-${key}`] = colorConfig[key];
        styles[key] = colorConfig[key];
    }
    return styles;
}
exports.ColorConfigToCSSVariables = ColorConfigToCSSVariables;
//# sourceMappingURL=ColorConfig.helpers.js.map